// extracted by mini-css-extract-plugin
module.exports = {"amountRow":"Amount_amountRow__e6rQq","amount":"Amount_amount__1Khlv","tip":"Amount_tip__3zv31","tipHeader":"Amount_tipHeader__2ZRUq","tipsWrap":"Amount_tipsWrap__3KLwT"};